import { axios } from "../main";
import convert from "xml-js";
import { IShoppingCartVueModel } from "./models/IShoppingCartVueModel";

export class ApiFunctions {
    private formConfig: any = { header: { "Accept": "application/json", "Content-Type": "multipart/form-data" } };

    async searchApplication(applicationNumber: string, searchtype: string): Promise<IResult> {
        return await axios.get<IResult>("api/Search/Application", { params: { applicationNumber: applicationNumber, type: searchtype } })
            .then(result => result.data);
    }

    async checkout(applicationNumber: string): Promise<IShoppingCartVueModel> {
        return await axios.get<IShoppingCartVueModel>("api/ShoppingCart/Checkout", { params: { applicationNumber: applicationNumber } })
            .then(result => result.data);
    }

    async payCredit(applicationNumber: string): Promise<HTMLFormElement> {
        return await axios.post<IPostCreditFormData>(`api/Pay/Credit?applicationNumber=${applicationNumber}`)
            .then(result => this.getCreditCardPaymentForm(result.data));
    }
    async payAch(applicationNumber: string, formName: string): Promise<IResult> {
        return await axios.post<IPostAchResult>(`api/Pay/Ach?applicationNumber=${applicationNumber}&formName=${formName}`)
            .then(result => this.getPostAchRedirect(result));
    }

    async confirmCredit(applicationNumber: string): Promise<IResult> {
        return await axios.post<IResult>(`api/Pay/ConfirmCredit?applicationNumber=${applicationNumber}`)
            .then(result => result.data);
    }
    async confirmAch(data: any): Promise<IResult> {
        return await axios.post<IResult>("api/Pay/ConfirmAch", data)
            .then(result => result.data);
    }
    async confirmNoPay(applicationNumber: string): Promise<IResult> {
        return await axios.post<IResult>(`api/Pay/ConfirmNoPay?applicationNumber=${applicationNumber}`)
            .then(result => result.data);
    }
    
    async getForm(formType: string, formName: string, applicationNumber?: string): Promise<any> {
        applicationNumber = applicationNumber === undefined ? "" : applicationNumber;
        return await axios.get<any>(`api/${formType}/Get${formName}?applicationNumber=${applicationNumber}`)
            .then(result => result.data);
    }

    async GetApprovedPermit(permitNumber: string): Promise<IResult> {
        return await axios.get<IResult>(`api/Permit/Approved?permitNumber=${permitNumber}`)
            .then(result => result.data)
    }

    async saveForm(formType: string, formName: string, form: FormData): Promise<IResult> {
        return await axios.post<IResult>(`api/${formType}/Save${formName}`, form, this.formConfig)
            .then(result => result.data);
    }

    async deleteFile(formId: string, fileId: string): Promise<IResult> {
        return await axios.post<IResult>(`api/Attachments/Delete?formId=${formId}&attachmentId=${fileId}`)
            .then(result => result.data);
    }

    async getFacilities(siteType: string | null): Promise<IResult> {
        if (siteType == null)
        {
            siteType = "All";
        }
        return await axios.get<IResult>(`api/Facility/Get?siteType=${siteType}`)
            .then(result => result.data);
    }

    async getContacts(facilityId: string): Promise<IResult> {
        return await axios.get<IResult>(`api/Contacts/Get?facilityId=${facilityId}`)
            .then(result => result.data);
    } 

    async getPermitPdf(permitNumber: string): Promise<IResult> {
        return await axios.get<IResult>(`api/Permit/Get?permitNumber=${permitNumber}`)
            .then(result => result.data);
    }

    async completeReport(applicationNumber: string): Promise<IResult> {
        return await axios.post<IResult>(`api/Reporting/Complete?applicationNumber=${applicationNumber}`)
            .then(result => result.data);
    }

    async getFacilityPermits(facilityId: string): Promise<IResult> {
        return await axios.get<IResult>(`api/Facility/GetPermits?facilityId=${facilityId}`)
            .then(result => result.data);
    }

    private getCreditCardPaymentForm(result: IPostCreditFormData): HTMLFormElement {

        let htmlForm = document.createElement("form");
        htmlForm.method = "post";
        htmlForm.action = result.postUrl;

        let htmlInput = document.createElement("input");
        htmlInput.name = "ORDER_XML";
        htmlInput.type = "hidden";
        htmlInput.value = this.getCreditCardPaymentXml(result);

        htmlForm.appendChild(htmlInput);
        document.body.appendChild(htmlForm);
        
        return htmlForm;
    }

    private getCreditCardPaymentXml(data: IPostCreditFormData): string {
        let jsonData = {
            _declaration: {
                _attributes: {
                    version: "1.0",
                    encoding: "utf-8"
                }
            },
            multiLineFormPostRequest: {
                bypassReceiptUrl: data.returnUrl,
                lexisNexisCode: 71527,
                paymentLineItems: [
                    {
                        productLines: [
                            {
                                productAmount: data.total.toFixed(2),
                                lexisNexisProductCode: "DES Online Payment",
                                refField: "SW" + data.applicationNumber,
                                refField1: data.shoppingCartId,
                            }
                        ]
                    }
                ]
            }
        }
        
        return convert.json2xml(JSON.stringify(jsonData), {compact: true, spaces: 4});
    }

    private getPostAchRedirect(result: any): IResult {
        return { isSuccess: true, message: result.data };
    }
}

export interface IResult {
    isSuccess: boolean;
    message?: string | string[];
}

interface IPostCreditFormData {
    postUrl: string;
    returnUrl: string;
    total: number;
    applicationNumber: number;
    shoppingCartId: string;
    validationCode: string;
}

interface IPostAchResult {
    postUrl: string;
    code: string;
    description: string;
}

export default new ApiFunctions();
